/* Authenticated fetch helper for the Worker API. The Clerk session token is
   attached as a Bearer header; the Worker resolves the caller's workspace from
   it. `setApiTokenGetter` is wired once from AppShell (which has useAuth). */
type TokenGetter = () => Promise<string | null>;

let getToken: TokenGetter = async () => null;

export function setApiTokenGetter(fn: TokenGetter): void {
  getToken = fn;
}

/** For the rare non-JSON request (file downloads) that needs the bearer token directly. */
export const getApiToken = () => getToken();

export class ApiError extends Error {
  constructor(readonly status: number, readonly code: string | null, message: string) {
    super(message);
  }
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const token = await getToken();
  const headers = new Headers(init.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  // FormData sets its own multipart boundary; only JSON bodies get a content type here.
  if (init.body && !(init.body instanceof FormData) && !headers.has('content-type')) headers.set('content-type', 'application/json');
  const res = await fetch(path, { ...init, headers });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    let code: string | null = null;
    try { code = (JSON.parse(body) as { error?: string }).error ?? null; } catch { /* not JSON */ }
    throw new ApiError(res.status, code, `API ${res.status}${body ? `: ${body}` : ''}`);
  }
  return res.json() as Promise<T>;
}
